import { QuotaCriteria } from '@ps/survey-utils';
import { BasePayloadMapper } from '@ps/utils';
import { QuotaCriterionDto } from '../dtos/survey-quota.dto';

export class QuotaCriteriaPayloadMapper extends BasePayloadMapper<
  QuotaCriteria[],
  QuotaCriterionDto[]
> {
  public toPayload(data: QuotaCriteria[]): QuotaCriterionDto[] {
    return data.map((criterion) => ({
      qualification_code: criterion.qualificationCode,
      qualification_name: criterion.qualificationName,
      condition_codes: criterion.conditionCodes,
      condition_names: criterion.conditionNames,
      range_sets: criterion.rangeSets ?? [],
      original_maximum: criterion.originalMaximum,
      original_minimum: criterion.originalMinimum,
      original_percentage: criterion.originalPercentage,
      original_required_count: criterion.originalRequiredCount,
      original_number: criterion.originalNumber,
      original_flex: criterion.originalFlex,
    }));
  }
}
